import useAuth from 'hooks/useAuth';
import { useQuery } from 'react-query';
import { User } from 'types/user';

export default function useTherapists(includeAllTherapists?: boolean) {
  const { request } = useAuth();

  const { data: therapists, isLoading: therapistsLoading } = useQuery(
    ['/therapists', includeAllTherapists],
    () =>
      request
        .get('/therapists', {
          params: { includeAllTherapists }
        })
        .then((response) => response.data.users as User[]),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false
    }
  );

  return { therapists, therapistsLoading };
}
